module.exports = __webpack_public_path__ + "static/img/3.f029577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/3.png
// module id = trRk
// module chunks = 0